import type { ReactiveVar } from '@apollo/client';
import { makeVar } from '@apollo/client';
import type { Message } from '@aurora/shared-generated/types/graphql-schema-types';

export const deepLinkMessageVar: ReactiveVar<Message> = makeVar(null);
export const updatedMessageForDeepLinkVar: ReactiveVar<Message> = makeVar(null);
export const updatedLocalStateForNewMessageVar: ReactiveVar<Message> = makeVar(null);
